module.exports = require('./helpers/bundle-url').getBundleURL('lPpKD') + "white.a9112886.svg" + "?" + Date.now();